import type { ThemeOptions } from '@mui/material';
import type { Tokens } from '@zeus/themes';

export function createChipStyles(tokens: Tokens) {
  return {
    MuiChip: {
      styleOverrides: {
        root: ({ theme }) => ({
          '.MuiChip-iconMedium': {
            height: '24px',
            width: '24px',
          },
          '.MuiChip-iconSmall': {
            height: '16px',
            width: '16px',
          },
          '&.Mui-focusVisible': {
            borderRadius: `${theme.ui.focus.borderRadius}`,
            outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
            outlineOffset: `${theme.ui.focus.outlineOffset}`,
          },
          '&.MuiChip-sizeMedium': {
            '&>.MuiChip-label': {
              padding: `${tokens.ui.chip.medium.label.spacing.vertical} ${tokens.ui.chip.medium.label.spacing.horizontal}`,
            },
            height: '36px',
            padding: `${tokens.ui.chip.medium.spacing.vertical} ${tokens.ui.chip.medium.spacing.horizontal}`,
          },
          '&.MuiChip-sizeMedium .MuiChip-avatar, &.MuiChip-sizeMedium .MuiChip-icon':
            {
              marginLeft: 0,
              marginRight: tokens.ui.chip.medium.spacing.horizontal,
            },
          '&.MuiChip-sizeMedium .MuiChip-deleteIcon': {
            marginLeft: tokens.ui.chip.medium.spacing.horizontal,
            marginRight: 0,
          },
          '&.MuiChip-sizeSmall': {
            '&>.MuiChip-label': {
              padding: `${tokens.ui.chip.small.label.spacing.vertical} ${tokens.ui.chip.small.label.spacing.horizontal}`,
            },
            height: '20px',
            padding: `${tokens.ui.chip.small.spacing.vertical} ${tokens.ui.chip.small.spacing.horizontal}`,
          },
          '&.MuiChip-sizeSmall .MuiChip-avatar, &.MuiChip-sizeSmall .MuiChip-icon':
            {
              marginLeft: 0,
              marginRight: tokens.ui.chip.small.spacing.horizontal,
            },
          '&.MuiChip-sizeSmall .MuiChip-deleteIcon': {
            marginLeft: tokens.ui.chip.small.spacing.horizontal,
            marginRight: 0,
          },
          borderRadius: `${tokens.ui.chip.border.radius}px`,
          fontSize: `${tokens.ui.chip.label.typography.fontSize}px`,
          lineHeight: `${tokens.ui.chip.label.typography.lineHeight}px`,
        }),
      },
    },
  } as ThemeOptions['components'];
}
